<template>
  <v-container v-if="!loadingProduto && produto.id">
    <v-row dense>
      <v-col>
        <px-listagem-estoque :produto-id="produto.id"/>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ListagemEstoque from '@/modules/estoque/ListagemEstoque.vue';

export default {
  props: {
    produto: Object,
    loadingProduto: Boolean,
  },
  components: {
    pxListagemEstoque: ListagemEstoque,
  },
};
</script>
